import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppSettings } from '../../app.constant';
import { UserService } from '../../shared/services/user.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleTableComponent } from '../../private/tables/module-table/module-table.component';
import { Alert } from 'selenium-webdriver';
import { transition, useAnimation, trigger } from '@angular/animations';
import { slideInLeft } from 'ng-animate'

@Component({
  selector: 'module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.css'],
  animations: [
    trigger('Warp-left', [transition('* => *', useAnimation(slideInLeft,
      {
        params: { timing: 2, delay: 1 }
      }))])]
})

export class ModuleComponent implements OnInit {
  moduleForm: FormGroup;
  httpResponseMessage: any;
  submitted = false;
  post: any;
  Module: any;
  errorMessage: String;
  programs: any;
  moduleentity: any;
  PK_ModuleID: any = '';
  FK_ProgramID: any = '';
  ProgramCode: any;
  ModuleCode: any = '';
  ModuleName: any = '';
  Core: any = '';
  Elective: any = '';
  buttonTitle: String = 'S A V E ';
  newtitle: String = " N E W ";

  @ViewChild(ModuleTableComponent) moduletable;
  constructor(
    private FormBuilder: FormBuilder,
    private _moduleService: ModuleService,
    private _programService: ProgramService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.moduleForm = this.FormBuilder.group({
      'PK_ModuleID': ['',],
      'FK_ProgramID': ['', Validators.required],
      'ModuleCode': ['', [Validators.required, Validators.maxLength(10)]],
      'ModuleName': ['', [Validators.required, Validators.maxLength(250)]],
      'Core': ['', [Validators.required, Validators.maxLength(5)]],
      'Elective': ['', [Validators.required, Validators.maxLength(5)]]
    })
    this._programService.refreshNeeded$
      .subscribe(() => {
        this.getAllProgram();
      })
    this.getAllProgram();
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.moduleForm.controls[controlName].hasError(errorName);
  }

  receiveData($event) {
    this.moduleentity = $event
    this.PK_ModuleID = this.moduleentity[0].PK_ModuleID;
    this.FK_ProgramID = this.moduleentity[0].FK_ProgramID;
    this.ProgramCode = this.moduleentity[0].ProgramCode;
    this.ModuleCode = this.moduleentity[0].ModuleCode;
    this.ModuleName = this.moduleentity[0].ModuleName;
    this.Core = this.moduleentity[0].Core;
    this.Elective = this.moduleentity[0].Elective;

  }
  cleardata() {
    this.moduleForm.reset();
  }

  getAllProgram(): void {
    this._programService.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  getBatchCode(ProgramCode) {
    console.log(ProgramCode);

  }

  getAllModule(): void {
    this._moduleService.getAllModule(AppSettings.API_ENDPOINT + AppSettings.GetAllModule).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  postModule(post): void {
    if (this.moduleForm.invalid) {
      return;
    }
    if (post.PK_ModuleID != '' && post.PK_ModuleID != null) {
      this.updateModule(post);
    }
    else {
      this.createModule(post);
    }
  }

  createModule(post): void {
    if (this.moduleForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);

    this._moduleService.postModule(AppSettings.API_ENDPOINT + AppSettings.CreateModule, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.moduleForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  updateModule(post) {
    if (this.moduleForm.invalid) {
      return;
    }
    this.post = JSON.stringify(post);
    this._moduleService.updateModule(AppSettings.API_ENDPOINT + AppSettings.UpdateModule, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.moduleForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }

}
